<div class="new-version">
  new version of pitwall.live available
  <div class="new-version__buttons">
    <button class="primary" (click)="reload()">load it now</button>
  </div>
</div>
